import { getStore } from '@/store'
import { actionCreators } from '../store/Cache'
import debug from 'debug'

const log = debug('app:store:cache')

export default function (key, fallbackFunc) {
  return function (...args) {
    const cacheKey = args && args.length ? key + JSON.stringify(args) : key
    const state = getStore().getState()
    const cache = state.cache
    if (cache) {
      const data = cache[cacheKey]
      if (data) {
        if (data instanceof Promise) return data
        return new Promise(resolve => resolve(data))
      }
    }

    const promise = fallbackFunc.apply(undefined, args).then(data => {
      getStore().dispatch(actionCreators.cacheData(cacheKey, data))
      return data
    }).catch(err => {
      getStore().dispatch(actionCreators.cacheData(key, null))
      log(`Retrieving data for cached value '${cacheKey}' failed. %O`, err)
    })

    getStore().dispatch(actionCreators.cacheData(cacheKey, promise))
    return promise
  }
};



// WEBPACK FOOTER //
// ./src/utils/cache.js